// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__vHKie","header":"MergedInvoice_header__2ctG1"};